import { createContext, useContext } from 'react';

type TickerContextType = {
  now: Date;
};

export const TickerContext = createContext<TickerContextType | null>(null);

export const useTickerContext = () => useContext(TickerContext)!;
